import { render, staticRenderFns } from "./WordsCloud.vue?vue&type=template&id=ba307b16&scoped=true"
import script from "./WordsCloud.vue?vue&type=script&lang=js"
export * from "./WordsCloud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba307b16",
  null
  
)

export default component.exports